// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import BootstrapVue from 'bootstrap-vue';
import VueMask from 'v-mask';
// import 'chart.js';
// import 'hchs-vue-charts';

import App from './App';
import router from './router';
import store from './store';


Vue.use(BootstrapVue);
Vue.use(VeeValidate);
Vue.use(VueMask);
// Vue.use(window.VueCharts);

Vue.config.productionTip = false;
Vue.config.debug = true;
Vue.config.devtools = true;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: {
        App,
    },
});



// WEBPACK FOOTER //
// ./src/main.js